export default __webpack_public_path__ + "static/studycafe-circle-8cad0bd106f14384ea3e91ecdc446f13.png";